// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AccountInReview_container__Alv4F {
  display: flex;
  flex-direction: column;
  background-color: var(--color-white);
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
}

.AccountInReview_inReview__YWNUe {
  height: 25rem;
}

.AccountInReview_logo__OQLbt {
  height: 3.8rem;
  margin-bottom: 3rem;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/Onboarding/AccountInReview.module.scss"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,sBAAA;EACA,oCAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,aAAA;AACJ;;AAEA;EACC,aAAA;AACD;;AAEA;EACC,cAAA;EACG,mBAAA;AACJ","sourcesContent":[".container {\n    display: flex;\n    flex-direction: column;\n    background-color: var(--color-white);\n    align-items: center;\n    justify-content: center;\n    width: 100vw;\n    height: 100vh;\n}\n\n.inReview {\n\theight: 25rem;\n}\n\n.logo {\n\theight: 3.8rem;\n    margin-bottom: 3rem;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AccountInReview_container__Alv4F`,
	"inReview": `AccountInReview_inReview__YWNUe`,
	"logo": `AccountInReview_logo__OQLbt`
};
export default ___CSS_LOADER_EXPORT___;
